import React from 'react';
import styled, { css } from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { goToTop } from '_helpers';
import { colors } from '_styles';
import { _ } from '_locales';

import HOC from '_HOC';

import DownloadAppBanner from './DownloadAppBanner';
import { BrandedAppNumber } from '../constants/brandedAppNumber';

const parentWidth = document.getElementById('rcroot').getBoundingClientRect().width;

const Wrapper = styled.footer`
  padding: 0 20px;
  box-sizing: border-box;
`;

const Container = styled.div`
  width: 100%;
`;

const BottomSideContainer = styled.div`
  width: 100%;
  margin: 23px 0;
  display: inline-block;
`;

const BottomSideInner = styled.div`
  display: flex;  

  button {
    color: ${colors.RC_ACTION} !important;
    text-decoration: none !important;

    &:hover {
      color: ${colors.RC_ACTION} !important;
      text-decoration: none !important;
    }
  }

  ${(parentWidth < 831) && css`
    display: flex;
  `};
`;

const ButtonContainer = styled.div`
  float: left;

  ${(parentWidth < 831) && css`
    flex: 1;
    float: initial;
    text-align: center;
  `};

  ${(parentWidth < 341) && css`
    button {
      font-size: 12px !important;
    }
  `};
`;

const Link = styled.a`
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: capitalize;

  color: ${colors.RC_ACTION} !important;

  &:hover {
    color: ${colors.RC_ACTION} !important;
    /* text-decoration: none !important; */
  }

  ${(parentWidth < 831) && css`
    flex: 1;
    text-align: center;
  `};

  ${(parentWidth < 341) && css`
    font-size: 12px !important;
    padding-top: 4px !important;
  `};
`;

const Button = styled.button`
  padding: 0px !important;
  height: auto;
  width: max-content;
  background-color: rgb(255, 255, 255) !important;
  border: none !important;
  cursor: pointer;
  font-size: 14px !important;
   
  font-weight: 500 !important;
  background-color: #fff !important;
  border: none !important;
  cursor: pointer !important;
  text-transform: capitalize !important;
`;

const policyUrl = process.env.REACT_APP_PRIVACY_POLICY_URL;
const userAgreementUrl = process.env.REACT_APP_USER_AGREEMENT_URL;
const circularMaterialsPrivacyPolicyUrl = process.env
  .REACT_APP_CIRCULAR_MATERIALS_PRIVACY_POLICY_URL;

const WebappFooter = ({ config }) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { districtId, webappConfig } = config;
  const {
    has_wgw: hasWgw, has_app_download: hasAppDownload, app_download_branded_app
  } = webappConfig || {
    has_wgw: false, has_app_download: false, app_download_branded_app: 0
  };

  const isCMApp = app_download_branded_app
    === BrandedAppNumber.CIRCULAR_MATERIALS;
  const clickHandler = () => {
    goToTop();
    if (pathname === '/material-list') return;
    history.push('/material-list');
  };

  const pagesToDisplayDownloadAppBanner = ['/wgw', '/cal',];
  // eslint-disable-next-line max-len
  const showDownloadAppBanner = pagesToDisplayDownloadAppBanner.find((page) => page === pathname);
  return (
    <Wrapper role="contentinfo">
      <Container>
        {hasAppDownload && showDownloadAppBanner && <DownloadAppBanner />}

        <BottomSideContainer>
          <BottomSideInner>

            {
              districtId
                && hasWgw ? (
                <ButtonContainer>
                  <Button onClick={clickHandler} aria-label="open the material list">{_('general.material_list')}</Button>
                </ButtonContainer>
              ) : null
            }

            <Link
              href={userAgreementUrl}
              target="_blank"
              rel="noreferrer"
              alt="terms and conditions link"
              style={{ marginLeft: 'auto' }}
            >
              {_('cal.user_agreement')}
            </Link>

            <Link
              href={isCMApp ? circularMaterialsPrivacyPolicyUrl : policyUrl}
              target="_blank"
              rel="noreferrer"
              alt="privacy policy link"
              style={{ margin: '0 10px' }}
            >
              {_('cal.privacy_policy')}
            </Link>
          </BottomSideInner>
        </BottomSideContainer>
      </Container>
    </Wrapper>
  );
};

export default HOC(WebappFooter);
